module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "order-confirmation-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n        Loading order details...\n      ")]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('div', {
    staticClass: "error-icon"
  }, [_vm._v("⚠️")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "btn-home",
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }, [_vm._v("\n          Go to Home\n        ")])]) : (_vm.order) ? _c('div', {
    staticClass: "confirmation-content"
  }, [_c('div', {
    staticClass: "success-header"
  }, [_c('div', {
    staticClass: "success-icon"
  }, [_vm._v("✓")]), _vm._v(" "), _c('h1', [_vm._v("Order Confirmed!")]), _vm._v(" "), _c('p', [_vm._v("Thank you for your purchase. Your order has been received and is being processed.")])]), _vm._v(" "), _c('div', {
    staticClass: "order-details-card"
  }, [_c('div', {
    staticClass: "order-header"
  }, [_c('div', {
    staticClass: "order-info"
  }, [_c('h2', [_vm._v("Order #" + _vm._s(_vm.order.order_number))]), _vm._v(" "), _c('p', {
    staticClass: "order-date"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.order.created_at)))])]), _vm._v(" "), _c('div', {
    staticClass: "order-status"
  }, [_c('span', {
    class: ['status-badge', _vm.order.status]
  }, [_vm._v("\n                " + _vm._s(_vm.formatStatus(_vm.order.status)) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-items-section"
  }, [_c('h3', [_vm._v("Order Items")]), _vm._v(" "), _c('div', {
    staticClass: "order-items"
  }, _vm._l((_vm.order.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "item-image"
    }, [(item.product && item.product.images && item.product.images.length > 0) ? _c('img', {
      attrs: {
        "src": _vm.getPrimaryImage(item.product).image_url,
        "alt": item.product_name
      }
    }) : _c('div', {
      staticClass: "no-image"
    }, [_vm._v("No Image")])]), _vm._v(" "), _c('div', {
      staticClass: "item-details"
    }, [_c('div', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('div', {
      staticClass: "item-variants"
    }, [(item.color) ? _c('span', [_vm._v(_vm._s(item.color))]) : _vm._e(), _vm._v(" "), (item.size) ? _c('span', [_vm._v(_vm._s(item.size))]) : _vm._e()]), _vm._v(" "), (item.product_variant && item.product_variant.sku) ? _c('div', {
      staticClass: "item-sku"
    }, [_vm._v("\n                    SKU: " + _vm._s(item.product_variant.sku) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-quantity"
    }, [_vm._v("\n                  Qty: " + _vm._s(item.quantity) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-price"
    }, [_vm._v("\n                  $" + _vm._s(_vm.formatPrice(item.unit_price_cents)) + "\n                ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "shipping-section"
  }, [_c('h3', [_vm._v("Shipping Address")]), _vm._v(" "), _c('div', {
    staticClass: "shipping-address"
  }, [_c('p', [_vm._v(_vm._s(_vm.order.shipping_first_name) + " " + _vm._s(_vm.order.shipping_last_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.shipping_address_line1))]), _vm._v(" "), (_vm.order.shipping_address_line2) ? _c('p', [_vm._v(_vm._s(_vm.order.shipping_address_line2))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.shipping_city) + ", " + _vm._s(_vm.order.shipping_state) + " " + _vm._s(_vm.order.shipping_postal_code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.shipping_country))]), _vm._v(" "), _c('p', {
    staticClass: "shipping-email"
  }, [_vm._v(_vm._s(_vm.order.shipping_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-summary"
  }, [_c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Subtotal")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.order.subtotal_cents)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "free-shipping"
  }, [_vm._v("FREE")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row total"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.order.total_cents)))])])]), _vm._v(" "), _c('div', {
    staticClass: "email-notice"
  }, [_c('p', [_vm._v("📧 A confirmation email has been sent to "), _c('strong', [_vm._v(_vm._s(_vm.order.shipping_email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [(_vm.isAuthenticated) ? _c('button', {
    staticClass: "btn-orders",
    on: {
      "click": function($event) {
        _vm.$router.push('/orders')
      }
    }
  }, [_vm._v("\n            View My Orders\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-shop",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n            Continue Shopping\n          ")])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3abff0ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/OrderConfirmation.vue
// module id = 287
// module chunks = 1